import { render, staticRenderFns } from "./PoiDetails.vue?vue&type=template&id=30d566a4&"
import script from "./PoiDetails.vue?vue&type=script&lang=js&"
export * from "./PoiDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports